import { render } from "./v-main-wrapper.vue?vue&type=template&id=62b6d5c6"
import script from "./v-main-wrapper.vue?vue&type=script&lang=js"
export * from "./v-main-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__